import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Backdrop,
  CircularProgress,
  Grid,
  Button,
  Card,
  TextField,
  MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { makeStyles } from '@material-ui/styles';
import SearchIcon from '@material-ui/icons/Search';
import { getUser } from 'src/utils/Common';
import moment from 'moment';
import GenericReportTable from '../../components/GenericReportTable';
import GenericDatePicker from '../../components/GenericDatePicker';

const useStyles = makeStyles(theme => ({
  root: {},
  review: {
    marginTop: theme.spacing(2)
  },
  gridDatePicker: {
    padding: '20px'
  }
}));

function AssignedJobs({ className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('Dashboard');
  const [reportData, setReportData] = useState([]);
  const [durum, setDurum] = useState('4');
  const [statusData, setStatusData] = useState([]);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [durumAciklama, setDurumAciklama] = useState(t('Son_Durum'));
  const [loading, setLoading] = useState(true);
  const SessionUser = getUser();

  useEffect(() => {
    axios
      .get('/GetSiriusCloseStatus')
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setStatusData(Deger);
        }
        setLoading(false);
      })
      .catch(error => {
        setStatusData([]);
        setLoading(false);
      });
  }, [SessionUser.ServiceShopId]);

  const getData = () => {
    setLoading(true);
    axios
      .get(
        `/GetDashboardAssignedJobs/${durum}/${baslangicTarihi}/${bitisTarihi}`
      )
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setReportData([]);
        } else {
          setReportData(ResponseData);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  const handleChangeDurum = event => {
    setDurum(event.target.value);
  };
  const handleStatusChangeText = event => {
    // setDurumAciklama(event.target.innerText);
  };
  const dataListCells = [
    {
      id: 'workCaseNr',
      numeric: true,
      disablePadding: true,
      label: t('txtWorkOrder')
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: true,
      label: t('txtStatus')
    },
    {
      id: 'customer',
      numeric: false,
      disablePadding: true,
      label: t('txtCustomer')
    },
    { id: 'phone', numeric: false, disablePadding: true, label: t('txtPhone') },
    {
      id: 'technician',
      numeric: false,
      disablePadding: true,
      label: t('txtTechnician')
    },
    { id: 'issue', numeric: false, disablePadding: true, label: t('txtIssue') }
  ];

  return (
    <Card className={clsx(classes.root, className)}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Grid container spacing={1} className={classes.gridDatePicker}>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              fullWidth
              select
              label={t('txtStatus')}
              id="StatusId"
              onChange={handleChangeDurum}
              value={durum || '4'}
              variant="outlined"
            >
              {statusData?.map(p => {
                return (
                  <MenuItem
                    onClick={handleStatusChangeText}
                    key={p.StatusId}
                    value={p.StatusId}
                  >
                    {p.FieldText}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={3}>
            <GenericDatePicker
              datePickerLabel={t('lblStartDate')}
              selectedDate={baslangicTarihi}
              handleDateChange={value => setBaslangicTarihi(value)}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <GenericDatePicker
              datePickerLabel={t('lblEndDate')}
              selectedDate={bitisTarihi}
              handleDateChange={value => setBitisTarihi(value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => getData()}
              endIcon={<SearchIcon />}
            >
              {t('lblSearch')}
            </Button>
          </Grid>
        </Grid>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {reportData.length > 0 && (
          <Grid container spacing={1}>
            <GenericReportTable
              reportTitle={t('lblAssignedJobs')}
              reportHeader={dataListCells}
              reportData={reportData}
            />
          </Grid>
        )}
      </div>
    </Card>
  );
}
AssignedJobs.propTypes = {
  className: PropTypes.string
};

export default AssignedJobs;
